import { useCallback, useState } from 'react';
import { toggleSkimming } from '../state/actions/toggle-skimming';
import { saveSkimmingEnabled } from '../state/skimming-persistance';
import { useSkimmingEnabled, useWriteContext } from '../utils/use-context';
import { Button, ToolButton, Tooltip } from '@crabs-ai/ds-react';
import { useTranslations } from 'next-intl';
import { Skimming } from '@crabs-ai/web-icons';
import { SkimmingGuideDialog } from './skimming-guide-dialog';

export function SkimmingToggle() {
  const t = useTranslations();
  const writeContext = useWriteContext();
  const isSkimmingEnabled = useSkimmingEnabled();
  const [isGuideOpen, setIsGuideOpen] = useState(false);

  const handleToggle = useCallback(() => {
    writeContext.setState({
      update: (state) => {
        const newState = toggleSkimming(state);
        saveSkimmingEnabled(newState.isSkimmingEnabled);
        return newState;
      },
      commitToUndoStack: false,
    });
  }, [writeContext]);

  return (
    <>
      <Tooltip
        type="withButton"
        side="top"
        className="items-center"
        textNode={
          isSkimmingEnabled
            ? t('Editor.timeline-controls.skimming-off')
            : t('Editor.timeline-controls.skimming-on')
        }
        buttonNode={
          <Button
            size="xsmall"
            hierarchy="tertiary"
            onClick={() => setIsGuideOpen(true)}
          >
            {t('Editor.timeline-controls.skimming-what')}
          </Button>
        }
      >
        <ToolButton
          size="sm"
          isTransparent={false}
          state={isSkimmingEnabled ? 'selected' : 'default'}
          onClick={handleToggle}
          title={`${isSkimmingEnabled ? 'Disable Skimming' : 'Enable Skimming'} (S)`}
          aria-label={
            isSkimmingEnabled ? 'Disable Skimming' : 'Enable Skimming'
          }
          aria-pressed={isSkimmingEnabled}
          aria-keyshortcuts="KeyS"
        >
          <Skimming className="size-5" />
        </ToolButton>
      </Tooltip>

      <SkimmingGuideDialog
        open={isGuideOpen}
        onOpenChange={setIsGuideOpen}
      />
    </>
  );
}
